import { toast } from "sonner";
import request from "../../../helpers/request";
import { IPostConfigPtMonDigital } from "./types";

const DTO = (data: IPostConfigPtMonDigital) => {
  const {
    idLoja,
    idEquipamento,
    idGrupoMonitor,
    toleranciaTime,
    coordX,
    coordY,
    hrMsgEscaladaNV2,
    minMsgEscaladaNV2,
    hrMsgEscaladaNV3,
    minMsgEscaladaNV3,
  } = data;

  const checkDataEscalada = (data) => (!data ? "00" : data);

  return {
    ...data,
    idLoja: Number(idLoja),
    idEquipamento: Number(idEquipamento),
    idGrupoMonitor: Number(idGrupoMonitor),
    toleranciaTime: Number(toleranciaTime),
    coordX: Number(coordX),
    coordY: Number(coordY),
    timeMsgEscaladaNV2: `${checkDataEscalada(hrMsgEscaladaNV2)}:${checkDataEscalada(minMsgEscaladaNV2)}`,
    timeMsgEscaladaNV3: `${checkDataEscalada(hrMsgEscaladaNV3)}:${checkDataEscalada(minMsgEscaladaNV3)}`,
    msgNormalCustom: "",
    msgFalhaCustom: "",
  };
};

export const postConfigPtMonDigital = async (
  props: IPostConfigPtMonDigital,
) => {
  const url = `${process.env.REACT_APP_API}/MonDigital`;
  const data = DTO({
    ...props,
    valor: true,
  });

  delete data.hrMsgEscaladaNV2;
  delete data.minMsgEscaladaNV2;
  delete data.hrMsgEscaladaNV3;
  delete data.minMsgEscaladaNV3;

  try {
    const result = await request({
      url,
      method: "post",
      data,
      headers: { "Content-Type": "application/json" },
    });

    if (result.data.toLowerCase() !== "ok") {
      throw new Error(result.data);
    }

    toast.success("Configuração salva com sucesso!");
    return result.data;
  } catch (error: any) {
    const mensagemApi =
      error?.response?.data?.mensagem ??
      error?.response?.data ??
      error?.message;

    toast.error(
      typeof mensagemApi === "string" && mensagemApi.trim()
        ? mensagemApi
        : "Houve um erro ao salvar configuração!",
    );
    throw error;
  }
};
